import { Renderer, RenderItem } from './renderer'

export class ErrorRenderer extends Renderer {
  private context: CanvasRenderingContext2D

  constructor(canvas: HTMLCanvasElement) {
    super(canvas)
    const context = canvas.getContext('2d')
    if (!context) throw Error('Canvas 2D is not supported')
    this.context = context
  }

  setItems(items: RenderItem[]) {}

  render() {
    const ctx = this.context

    const { size } = this.state
    ctx.clearRect(0, 0, size.width, size.height)
    ctx.font = '24px Arial'
    ctx.textAlign = 'center'
    ctx.lineWidth = 1
    ctx.strokeStyle = '#000'
    ctx.fillStyle = `#f00`
    ctx.textBaseline = 'bottom'
    ctx.fillText(
      'Error: WebGL is not supported or',
      size.width / 2,
      size.height / 2,
      size.width
    )
    ctx.textBaseline = 'top'
    ctx.fillText(
      'hardware acceleration is disabled',
      size.width / 2,
      size.height / 2,
      size.width
    )
  }
}
